export default __webpack_public_path__ + "static/media/logoBICCapital.d490e28a.png";